<template>
  <generic-container
    icon="sitemap"
    :show_plus="true"
    :title="$t('prototype pages')"
    class="ui basic segment"
    @add="add"
    :header_buttons="header_buttons"
  >
    <div class="ui grid">
      <div class="four wide column">
        <div
          class="ui vertical fluid pointing menu"
          ref="tabs"
          v-if="setup.pages.length"
        >
          <a
            class="item"
            :data-tab="'x' + idx"
            v-for="(lyt, idx) in setup.pages"
            :key="idx"
          >
            <i class="settings icon" :class="{ blue: lyt.is_main }"></i>
            {{ lyt.name || $t("unnamed") }}
          </a>
        </div>
      </div>
      <div class="twelve wide stretched column">
        <div
          class="ui tab segment"
          :data-tab="'x' + idx"
          v-for="(tpl, idx) in setup.pages"
          :key="idx"
          style="margin-top:0"
        >
          <div class="ui form">
            <div class="fields">
              <div class="seven column wide field">
                <label for>{{ $t("name") }}</label>
                <input
                  type="text"
                  name="name"
                  v-model="setup.pages[idx].name"
                />
              </div>
              <div class="six column wide field">
                <label for="">{{ $t("main") }}</label>
                <div class="ui toggle checkbox" ref="is_main_checkbox">
                  <input
                    type="checkbox"
                    name="main"
                    :data-i="setup.pages[idx].id"
                    v-model="setup.pages[idx].is_main"
                  />
                  <label>{{ $t("set as main") }}</label>
                </div>
              </div>
              <div class="three column wide field">
                <label for="">{{ $t("options") }}</label>
                <div class="ui icon labeled red button" @click="remove(idx)">
                  <i class="trash icon"></i> {{ $t("delete") }}
                </div>
              </div>
            </div>
            <div class="field">
              <label for>{{ $t("name") }}</label>
              <textarea
                name="description"
                v-model="setup.pages[idx].description"
                rows="2"
              ></textarea>
            </div>
          </div>
          <h3 class="dividing header">{{ $t("code") }}</h3>
          <wysywyg v-model="setup.pages[idx].template" />
        </div>
      </div>
    </div>
  </generic-container>
</template>

<script>
import filters from "@/filters";
import GenericContainer from "@/components/GenericContainer";
import { v4 } from "uuid";
import Wysywyg from "@/components/Wysywyg/Wysywyg";

export default {
  name: "PrototypeComposerPages",
  components: { GenericContainer, Wysywyg },
  filters: filters,
  props: {
    setup: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {
    header_buttons() {
      // let vm = this;
      // if (vm.selected_page) {
      //   return [
      //     {
      //       tooltip: vm.$t("delete"),
      //       icon: "red trash",
      //       click: vm.remove,
      //       visibility_condition: false,
      //     },
      //   ];
      // } else {
      return [];
      // }
    },
  },
  methods: {
    add() {
      let vm = this;
      let template = {
        id: v4(),
        name: "",
        is_main: false,
        description: "",
        setup: {},
        template: {
          css: "",
          js: "",
          html: "",
        },
      };
      vm.setup.pages.push(template);
      setTimeout(() => {
        vm.itemize();
      }, 1000);
    },
    itemize() {
      let vm = this;
      window
        .jQuery(vm.$refs.tabs)
        .find(".item")
        .tab();

      if (vm.$refs.is_main_checkbox) {
        window.jQuery(vm.$refs.is_main_checkbox).checkbox({
          onChecked() {
            let pageId = window.jQuery(this).data("i");
            vm.setup.pages.map((p) => {
              p.is_main = false;
              if (p.id == pageId) p.is_main = true;
            });
          },
          onUnchecked() {},
        });
      }
    },
    remove(index) {
      let vm = this;
      vm.setup.pages.splice(index, 1);
      setTimeout(() => {
        vm.itemize();
      }, 1000);
    },
  },
  created() {},
  mounted() {
    let vm = this;
    if (vm.setup && vm.setup.pages) {
      setTimeout(() => {
        vm.itemize();
      }, 1000);
    }
  },
  watch: {},
};
</script>
